import { Basket, BasketProductItem } from "../../types/server";

export enum QueueStatusEnum {
  NOT_SYNCED = "not_synced",
  LOADING = "loading",
  SYNCED = "synced",
}

type BasketWithoutItems = Omit<Basket, "items">;
export interface ExtendedBasketProductItem extends BasketProductItem {
  status?: QueueStatusEnum;
}
export interface ExtendedBasket extends BasketWithoutItems {
  items: ExtendedBasketProductItem[];
}
export type QueueItem = {
  quantity: number;
  status: QueueStatusEnum;
};

export type BasketData = null | ExtendedBasket;
export type BasketQueue = {
  items: {
    [key in string]: QueueItem;
  };
  actions: any;
};
export type BasketState = {
  data: null | ExtendedBasket;
  queue: BasketQueue;
};

export const init_state: BasketState = {
  data: null,
  queue: {
    items: {},
    actions: {},
  },
};
